import {Component, ContentChildren, EventEmitter, Input, Output, QueryList} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatCard, MatCardActions, MatCardContent} from '@angular/material/card';
import {MatDivider} from '@angular/material/divider';
import {NgTemplateOutlet} from '@angular/common';
import {CardContent, CardContentRawDirective} from './card-content.directive';
import {MatIcon} from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * A component that takes creates a standard `<mat-card>` element with a leading `<h2>` tag as a title.
 * The `<mat-card>` will host one or more `<mat-card-content>` separated by a `<mat-divider>` based
 * on the number of provided `<xxx *appCardContent>` child elements.
 *
 * See `AppCardContent` directive.
 */
@Component({
  selector: 'app-card',
  imports: [MatCard, MatCardContent, MatDivider, NgTemplateOutlet, MatIconButton, MatIcon, MatCardActions, MatTooltip],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent {
  @ContentChildren(CardContent, { descendants: true }) content: QueryList<CardContent>;

  @Input() preCardTitle: string;

  @Input() inCardTitle: string;
  @Input() icon: string;
  @Input() iconDisabled = false;
  @Input() iconTooltip: string;

  @Input() actionIcon: string;
  @Input() actionIconDisabled = false;
  @Input() actionTooltip: string;

  @Input() action2Icon: string;
  @Input() action2IconDisabled = false;
  @Input() action2Tooltip: string;

  @Output() iconClicked = new EventEmitter<void>();
  @Output() actionIconClicked = new EventEmitter<void>();
  @Output() action2IconClicked = new EventEmitter<void>();

  protected readonly CardContentRawDirective = CardContentRawDirective;
}
